import { useState, useRef } from 'react';
import MobileHeaderContent from './MobileHeaderContent';
import DesktopHeaderContent from './DesktopHeaderContent';
import useStickyHeader from './useStickyHeader';
//Styles
import { StyledHeader } from './styles/StyledHeader';
//Content

const Header = ({ HeaderSTyle, content }) => {
  const ref = useRef();
  const sticky = useStickyHeader(50);
  const headerClasses = `header-wrapper ${sticky ? 'sticky' : ''}`;
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const toggleMobileMenu = () => {
    setShowMobileMenu(prev => !prev);
  };
  return (
    <StyledHeader>
      <header ref={ref} className={`header-wrapper ${sticky ? 'sticky' : ''} ${showMobileMenu ? 'mobile-menu-active' : ''}`}>
        <div className="header-content">
          <DesktopHeaderContent content={content} />
          <MobileHeaderContent content={content} showMobileMenu={showMobileMenu} toggleMobileMenu={toggleMobileMenu} />
        </div>
      </header>
    </StyledHeader>
  );
};
export default Header;

// CSS Structure
/*
.header-wrapper{
  .container{
    .header-content{

    }
  }
}
*/
